import React from "react";
import { Route, Routes } from "react-router-dom";
import Layout from "./Layout";
import Home from "./home";
import Places from "./places";
import AddPlace from "./addPlace";
import EditPlace from "./editPlace";
import TravelCategory from "./travelcategory";
import AddTravelCategory from "./addtravelcategory";
import EditTravelCategory from "./edittravelcategory";
import TourPackage from "./travelpackage";
import AddTourPackage from "./addTourPackage";
import EditTourPackage from "./editTourPackage";
import Amenities from "./amenity";
import AddAmenities from "./addAmenity";
import EditAmenities from "./editAmenity";
import BedTypes from "./bedType";
import AddBedTypes from "./addBedType";
import EditBedTypes from "./editBedType";
import PropertyTypes from "./propertyType";
import AddPropertyTypes from "./addPropertyType";
import EditPropertyTypes from "./editPropertyType";
import HotelAdmin from "./hotelAdmin";
import AddHotelOwner from "./addHotelAdmin";
import MyProperty from "./property";
import AddProperty from "./addProperty";
import EditProperty from "./editProperty";
import EditHotelOwner from "./edithotelAdmin";
import PackageDetails from "./packageDetails";
import HotelAdminDetails from "./hotelAdminDetails";
import EditHotel from "./editHotel";
import RoomTypes from "./roomType";
import AddRoomTypes from "./addRoomType";
import EditRoomTypes from "./editRoomType";
import Rooms from "./rooms";
import AddRooms from "./addRoom";
import EditRooms from "./editRoom";
import CopyRooms from "./copyroom";
import RoomsAvailability from "./room-availabiliity";
import AddRoomsAvailability from "./addAvailability";
import FerryServices from "./ferryservices";
import AddFerries from "./addferryservice";
import EditFerries from "./editferryservice";
import Enquiry from "./enquiry";
import CopyTourPackage from "./copytourPackage";
import CarRentalPackage from "./carrentalpackage";
import AddCarRentalPackage from "./addcarrentalPackage";
import EditCarRentalPackage from "./editcarrentalPackage";
import CopyCarRentalPackage from "./copycarrentalpackage";
import CarRentalPackageDetails from "./carrentalpackageDetails";
import CarType from "./carType";
import AddCar from "./addCar";
import EditCar from "./editCar";
import AirportCar from "./airportCharges";
import AddAirportCharges from "./addairportCharges";
import EditAirportCharges from "./editairportCharges";
import HourlyCar from "./hoourlyCarCharges";
import AddHourlyCharges from "./addHourlyCarCharges";
import EditHourlyCharges from "./editHourlyCarCharges";
import PlaceWiseHotel from "./placewisehotel";
import AddPlaceHotel from "./addplaceWiseHotel";
import EditPlaceHotel from "./editplacewiseHotel";
import PickupDrop from "./pickupDropCharges";
import EditPickupDrop from "./editpickupDrop";
import AddPickupDrop from "./addPickupDrop";
import WaterSport from "./waterSport";
import AddWaterSport from "./addwaterSport";
import EditWaterSport from "./editwaterSports";

const Dashboard = () => {
  return (
    <>
      <Layout>
        <div className="row gy-4 mb-24"></div>
        <Routes>
          <Route path="/home" element={<Home />} />
          <Route path="/places" element={<Places />} />
          <Route path="/add-place" element={<AddPlace />} />
          <Route path="/edit-place/:id" element={<EditPlace />} />
          <Route path="/travel-category" element={<TravelCategory />} />
          <Route path="/add-travel-category" element={<AddTravelCategory />} />
          <Route
            path="/edit-travel-category/:id"
            element={<EditTravelCategory />}
          />
          <Route path="/tour-package" element={<TourPackage />} />
          <Route path="/add-tour-package" element={<AddTourPackage />} />
          <Route path="/edit-tour-package/:id" element={<EditTourPackage />} />
          <Route path="/copy-tour-package/:id" element={<CopyTourPackage />} />
          <Route path="/package-details/:id" element={<PackageDetails />} />
          <Route path="/amenity" element={<Amenities />} />
          <Route path="/add-amenity" element={<AddAmenities />} />
          <Route path="/edit-amenity/:id" element={<EditAmenities />} />
          <Route path="/bedtype" element={<BedTypes />} />
          <Route path="/add-bedtype" element={<AddBedTypes />} />
          <Route path="/edit-bedtype/:id" element={<EditBedTypes />} />
          <Route path="/propertytype" element={<PropertyTypes />} />
          <Route path="/add-propertytype" element={<AddPropertyTypes />} />
          <Route
            path="/edit-propertytype/:id"
            element={<EditPropertyTypes />}
          />
          <Route path="/ferry-services" element={<FerryServices />} />
          <Route path="/add-ferry-service" element={<AddFerries />} />
          <Route path="/edit-ferry-service/:id" element={<EditFerries />} />

          <Route path="/hoteladmin" element={<HotelAdmin />} />
          <Route
            path="/hoteladmin-details/:id"
            element={<HotelAdminDetails />}
          />
          <Route path="/add-hotel-admin" element={<AddHotelOwner />} />
          <Route path="/edit-hotel/:id" element={<EditHotel />} />
          <Route path="/edit-hotel-admin/:id" element={<EditHotelOwner />} />
          <Route path="/property" element={<MyProperty />} />
          <Route path="/room-types" element={<RoomTypes />} />
          <Route path="/rooms/:id" element={<Rooms />} />
          <Route path="/add-property" element={<AddProperty />} />
          <Route path="/edit-property/:id" element={<EditProperty />} />
          <Route path="/add-roomtype" element={<AddRoomTypes />} />
          <Route path="/edit-roomtype/:id" element={<EditRoomTypes />} />
          <Route path="/add-room/:id" element={<AddRooms />} />
          <Route path="/edit-room/:id/:hotelId" element={<EditRooms />} />
          <Route path="/copy-room/:id/:hotelId" element={<CopyRooms />} />
          <Route
            path="/room-availability/:id"
            element={<RoomsAvailability />}
          />
          <Route
            path="/add-room-availability/:id"
            element={<AddRoomsAvailability />}
          />
          <Route path="/carrental" element={<CarRentalPackage />} />
          <Route
            path="/add-carrental-package"
            element={<AddCarRentalPackage />}
          />
          <Route
            path="/edit-carrental-package/:id"
            element={<EditCarRentalPackage />}
          />
          <Route
            path="/copy-carrental-package/:id"
            element={<CopyCarRentalPackage />}
          />
          <Route
            path="/carrental-package-details/:id"
            element={<CarRentalPackageDetails />}
          />
          <Route path="/enquiry" element={<Enquiry />} />
          <Route path="/car-types" element={<CarType />} />
          <Route path="/add-car-types" element={<AddCar />} />
          <Route path="/edit-car-types/:id" element={<EditCar />} />
          <Route path="/airport-charges" element={<AirportCar />} />
          <Route path="/add-airport-charges" element={<AddAirportCharges />} />
          <Route
            path="/edit-airport-charges/:id"
            element={<EditAirportCharges />}
          />
          <Route path="/hourly-car-charges" element={<HourlyCar />} />
          <Route path="/add-hourlycar-charges" element={<AddHourlyCharges />} />
          <Route
            path="/edit-hourlycar-charges/:id"
            element={<EditHourlyCharges />}
          />
          <Route path="/placewise-hotel" element={<PlaceWiseHotel />} />
          <Route path="/add-placewise-hotel" element={<AddPlaceHotel />} />
          <Route
            path="/edit-placewise-hotel/:id"
            element={<EditPlaceHotel />}
          />
          <Route path="/pickup-drop" element={<PickupDrop />} />
          <Route path="/add-pickup-drop" element={<AddPickupDrop />} />
          <Route path="/edit-pickup-drop/:id" element={<EditPickupDrop />} />
          <Route path="/watersports" element={<WaterSport />} />
          <Route path="/add-watersport" element={<AddWaterSport />} />
          <Route path="/edit-watersport/:id" element={<EditWaterSport />} />
        </Routes>
      </Layout>
    </>
  );
};

export default Dashboard;
